import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG, DATE_FORMAT_LONG_MINUTE } from 'CorePackage/MainModule/constants/dateFormat';

import { KnmSubtitle } from './KnmSubtitle';
import styles from './styles.module.scss';

interface IPmActProps {
  passportData?: IKnmPreview;
}

export const PmAct = ({ passportData }: IPmActProps) => {
  const act = passportData?.pmErknm?.subject?.act;
  const violations = act?.violations;

  return (
    <div className={styles.ColumnContent}>
      {act && (
        <KnmSubtitle title="Сведения об акте">
          {act.numberAct && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Номер акта ПМ</div>
              <div className={styles.ColValue}>{act.numberAct}</div>
            </div>
          )}
          {act.creationActDateTime && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Дата и время составления акта ПМ</div>
              <div className={styles.ColValue}>
                {formatDate({ date: act.creationActDateTime, dateFormat: DATE_FORMAT_LONG_MINUTE })}
              </div>
            </div>
          )}
          {act.holdingDateTime && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Дата и время начала проведения ПМ</div>
              <div className={styles.ColValue}>
                {formatDate({ date: act.holdingDateTime, dateFormat: DATE_FORMAT_LONG_MINUTE })}
              </div>
            </div>
          )}
          {typeof act.durationDays === 'number' && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Срок проведения (в днях)</div>
              <div className={styles.ColValue}>{act.durationDays}</div>
            </div>
          )}
          {typeof act.durationHours === 'number' && (
            <div className={styles.Row}>
              <div className={styles.ColText}>Срок проведения (в часах)</div>
              <div className={styles.ColValue}>{act.durationHours}</div>
            </div>
          )}
        </KnmSubtitle>
      )}
      {act && (
        <KnmSubtitle title="Выявленные нарушения обязательных требований">
          {violations?.length ? (
            violations.map((violation, index) => (
              <div className={styles.SectionBlock} key={index}>
                <div className={styles.SectionTitle}>Обязательное требование #{index + 1}</div>
                {violation.title && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Содержание требования</div>
                    <div className={styles.ColValue}>{violation.title}</div>
                  </div>
                )}
                {violation.number && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>НПА</div>
                    <div className={styles.ColValue}>
                      №{violation.number}
                      {violation.acceptanceDate &&
                        ` от ${formatDate({ date: violation.acceptanceDate, dateFormat: DATE_FORMAT_LONG })}`}
                    </div>
                  </div>
                )}
                {violation.structuralUnit?.title && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Структурная единица</div>
                    <div className={styles.ColValue}>{violation.structuralUnit.title}</div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className={styles.Row}>
              <span className={styles.ColText}>Выявленные нарушения обязательных требований отсутствуют</span>
            </div>
          )}
        </KnmSubtitle>
      )}
    </div>
  );
};
